import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Card, Modal, Button, Typography, notification, Flex, Space, Breadcrumb, Row, Col } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./routingMap.scss";
import { useDispatch } from "react-redux";
import { deleteRow, getData } from "../../../actions/apiCall";
import { postData, putData } from "../../../actions/developer";
import RouteEdit from "./RouteEdit";
import { DeleteOutlined } from "@ant-design/icons";
const { confirm } = Modal;
const { Text } = Typography;

interface ItemRecord {
    status?: string;
    _id?: string;
    name: string;
    parentMenu?: string;
    createdAt?: string;
    updatedAt?: string;
    subparentMenu?: string;
    routeUrl?: string;
    componentName?: string;
    icon?: string;
    order: number;
    subMenu?: string;
    mainMenuRef?: any;
    subMenuRef?: any;
    parentMenuRef?: any;
    newTab?: any;
    menuId?: string;
    parentId?: string;
    list?: ItemRecord[];
    isNew?: boolean;
}

interface ComponentProps {
    mainMenu?: ItemRecord;
}

const sort = (a: ItemRecord, b: ItemRecord) => {
    return a.order - b.order;
}

const RoutingTabs: React.FC<ComponentProps> = ({ mainMenu }) => {
    const [items, setItems] = React.useState<ItemRecord[]>([]);
    const [selectedTab, setSelectedTab] = React.useState<ItemRecord | null>(null);
    const [selectedAllTabs, setSelectedAllTabs] = React.useState<ItemRecord[]>([]);
    const [visible, setVisible] = React.useState(false);
    const dispatch = useDispatch();
    const [broadCampItems, setBroadCampItems] = React.useState<{ title: string }[]>([]);

    const getName = (item: ItemRecord) => {
        if (item?.parentMenu) return item?.parentMenu
        if (item?.subMenu) return item?.subMenu
        return item?.name
    }

    useEffect(() => {
        if (mainMenu) {
            setSelectedTab(null)
            setSelectedAllTabs([])
            getTabsList()
        }
    }, [mainMenu]);

    useEffect(() => {
        if (mainMenu) {
            const array = [];
            if (mainMenu.mainMenuRef) {
                array.push({ title: getName(mainMenu.mainMenuRef) });
            }
            if (mainMenu.subMenuRef) {
                array.push({ title: getName(mainMenu.subMenuRef) });
            }
            if (mainMenu.name) {
                array.push({ title: getName(mainMenu) });
            }
            setBroadCampItems(array);
        }
    }, [mainMenu])

    const updateRecords = async (_id, text) => {
        try {
            const resData = await dispatch(putData(`/routing/tab/list/${_id}`, { name: text }));
            if (resData) {
                getTabsList();
            } else {
                notification.error({ message: 'Error', description: resData.message });
            }
        } catch (error) {
            notification.error({ message: 'Error', description: error.message });
        }
    }

    const getTabsList = async () => {
        const resData = await dispatch(getData(`/routing/tab/list/${mainMenu._id}`));
        if (resData.code === 200) {
            setItems(resData.data.sort(sort));
        } else {
            notification.error({ message: 'Error', description: resData.message });
        }
    }

    const randomUID = () => {
        return Math.random().toString(36).substr(2, 9).toString();
    }


    const onDragEnd = (result: any, droppableId: string, parentId = undefined) => {
        const { source, destination } = result;
        if (!destination) return;

        if (source.droppableId === droppableId && destination.droppableId === droppableId) {
            const reordered = Array.from(items.filter(item => item.parentId === parentId));
            const [moved] = reordered.splice(source.index, 1);
            reordered.splice(destination.index, 0, moved);
            reordered.forEach((item, index) => item.order = index + 1);
            setItems([...items.filter(item => item.parentId !== parentId), ...reordered]);
            onSave(reordered);
        }
    };

    const onSave = async (tempData) => {
        const resData = await dispatch(postData('/routing/update-routes', tempData));
        if (resData) {
            getTabsList();
        }
    }

    const onAddTab = async (tab) => {
        const resData = await dispatch(postData(`/routing/tab/list`, { ...tab, menuId: mainMenu._id }));
        if (resData.code == 200) {
            console.log(resData.data);
            getTabsList();
        } else {
            notification.error({ message: 'Error', description: resData.message });
        }
    }

    const addTab = async (parrentId = '') => {
        const newItem: ItemRecord = { name: `New Tab ${Date.now()}`, order: items.length + 1 };
        if (parrentId) {
            newItem.parentId = parrentId;
        }
        await onAddTab(newItem)
    };

    const selectedAllTabsHandler = (item: ItemRecord) => {
        setSelectedTab(item);
        setSelectedAllTabs([item, ...findParentTabs(item._id)]);
    }

    const onDelete = async (_id) => {
        confirm({
            type: 'error',
            title: 'Do you want to delete this tab?',
            content: 'if you submit request then it will be deleted permanently. also it will delete all the child tabs.',
            async onOk() {
                const resData = await dispatch(deleteRow(`/routing/tab/delete/${_id}`));
                if (resData.code == 200) {
                    getTabsList();
                } else {
                    notification.error({ message: 'Error', description: resData.message });
                }
            },
            onCancel() {
                console.log('Cancel');
            },
        })
    }

    const onClose = () => {
        getTabsList();
        setVisible(false);
    }

    const getItems = (item: ItemRecord) => {
        const items = [{ title: process.env.CRM_URL }, ...item.routeUrl.split('/').map(ele => ({ title: ele }))];
        return items;
    }

    const findParentTabs = (itemId: string): ItemRecord[] => {
        const parents: ItemRecord[] = [];
        let currentItem = items.find(item => item._id === itemId);
        while (currentItem && currentItem.parentId) {
            currentItem = items.find(item => item._id === currentItem.parentId);
            if (currentItem) {
                parents.unshift(currentItem);
            }
        }
        return parents;
    };


    const renderTabs = (parrentId = undefined) => {
        const droppableId = randomUID();
        const itemsToRender = items.filter(item => item.parentId === parrentId);
        return <div className="tab-view-box">
            <DragDropContext onDragEnd={(result) => onDragEnd(result, droppableId, parrentId)}>
                <Droppable droppableId={droppableId} direction="horizontal">
                    {(provided) => (
                        <div className="tab-section">
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="tabs-view"
                            >
                                {itemsToRender.map((item, index) => (
                                    <Draggable key={item._id} draggableId={item._id} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className={"tab-item" + (selectedAllTabs.find(e => e._id == item._id) ? " active-tab" : "")}
                                                onClick={() => {
                                                    selectedAllTabsHandler(item)
                                                }}
                                            >
                                                <Text editable={{
                                                    triggerType: ['icon'],
                                                    onChange: (e) => updateRecords(item?._id, e)
                                                }} title={item?.name}>
                                                    {item.name}
                                                </Text>
                                                {selectedAllTabs.find(e => e._id == item._id) ? <Button type="text" icon={<DeleteOutlined />} onClick={() => onDelete(item?._id)} /> : <></>}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                            <Button onClick={() => addTab(parrentId)}>Add Tab</Button>
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div >
    }

    const renderEmptyTab = (parrentId = undefined) => {
        return <div className="tab-view-box">
            <div className="tab-section">
                <div>
                    <Flex gap={16}>
                        <Space>
                            {selectedTab && selectedTab?.componentName && <>
                                <Text>{selectedTab?.componentName}</Text>
                                <Breadcrumb
                                    items={getItems(selectedTab)}
                                />
                            </>}
                        </Space>
                        <Button type="link" onClick={() => setVisible(true)}>{selectedTab?.componentName ? 'Update Route' : 'Add Route'}</Button>
                    </Flex>
                    <RouteEdit editItem={selectedTab} open={visible} onClose={onClose} />
                </div>
                <Button onClick={() => addTab(parrentId)}>Add Tab</Button>
            </div>
        </div>
    }

    const renderHierarchy = (selectedItem: ItemRecord | null) => {
        if (!selectedItem) {
            return null;
        }

        const parentTabs = findParentTabs(selectedItem._id);
        const childItems = items.filter(item => item.parentId === selectedItem._id);

        return (
            <div>
                {parentTabs.map((parentTab) => (
                    <div key={parentTab._id}>
                        {renderTabs(parentTab._id)}
                    </div>
                ))}
                {childItems.length > 0 ?
                    renderTabs(selectedItem._id) :
                    renderEmptyTab(selectedItem._id)
                }
            </div>
        );
    };

    return (
        <Card title={<Flex justify="space-between">
            <Breadcrumb items={broadCampItems} />
            <Space direction="horizontal">
                <Breadcrumb separator={':'} items={[{ title: mainMenu && mainMenu?.componentName }, { title: mainMenu && mainMenu?.routeUrl }]} />
            </Space>
        </Flex>}>
            {renderTabs(undefined)}
            {renderHierarchy(selectedTab)}
        </Card>
    );
};

const mapStateToProps = (state: any) => ({
    isAuthenticated: state.app.isAuthenticated,
    user: state.app.user,
});

export default connect(mapStateToProps)(RoutingTabs);
